import { allGenericWorksheetModuleTypes } from "@arbeidsark/shared"
import type { WorksheetGenericLanguageModuleType } from "@arbeidsark/shared"
import { Select, type SelectOption, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface GenericTaskTypesSelectProps
  extends Omit<
    SelectProps<WorksheetGenericLanguageModuleType | null>,
    "options"
  > {}

const GenericLanguageTaskTypesSelect: React.FC<GenericTaskTypesSelectProps> = ({
  ...props
}) => {
  const translations = useTranslate({
    "generic/wordSearch": "worksheets.task-types.generic.wordSearch",
    "generic/crossword": "worksheets.task-types.generic.crossword",
    "generic/readingTexts": "worksheets.task-types.generic.readingTexts",
    random: "worksheets.labels.random",
  })

  const options: SelectOption<WorksheetGenericLanguageModuleType>[] =
    allGenericWorksheetModuleTypes.map((type) => ({
      value: type,
      label: translations[type],
    }))

  return (
    <Select {...props} options={options} placeholder={translations.random} />
  )
}

export default GenericLanguageTaskTypesSelect
